import { createReducer, on } from '@ngrx/store';
import { initialState } from './state';
import { BOOKING_ASSiSTANT_AUTOMATION } from './actions';
import { SessionActions } from '@state/session';

export const reducers = createReducer(
	initialState,
	on(BOOKING_ASSiSTANT_AUTOMATION.ENABLED_INTEGRATION.GET, (state) => ({
		...state,
		enabledIntegration: null,
		loading: true,
	})),
	on(BOOKING_ASSiSTANT_AUTOMATION.ENABLED_INTEGRATION.SUCCESS, (state, action) => ({
		...state,
		loading: false,
		enabledIntegration: action.data,
	})),

	on(BOOKING_ASSiSTANT_AUTOMATION.ENABLED_INTEGRATION_DATA_FIELDS.GET, (state) => ({
		...state,
		loading: true,
	})),
	on(BOOKING_ASSiSTANT_AUTOMATION.ENABLED_INTEGRATION_DATA_FIELDS.SUCCESS, (state, action) => ({
		...state,
		loading: false,
		enabledIntegrationDataFields: action.data,
	})),

	on(BOOKING_ASSiSTANT_AUTOMATION.BOOKING_ASSISTANT_DATA_FIELDS.GET, (state) => ({
		...state,
		loading: true,
	})),
	on(BOOKING_ASSiSTANT_AUTOMATION.BOOKING_ASSISTANT_DATA_FIELDS.SUCCESS, (state, action) => ({
		...state,
		loading: false,
		bookingAssistantDataFields: action.data,
	})),
	on(
		BOOKING_ASSiSTANT_AUTOMATION.BOOK_NOW_DATA.UPDATED,
		BOOKING_ASSiSTANT_AUTOMATION.BOOK_NOW_DATA.SET,
		(state, action) => ({
			...state,
			bookNowData: action.bookNowData,
		})
	),
	on(
		BOOKING_ASSiSTANT_AUTOMATION.EMAIL_ROUTING_DATA.UPDATED,
		BOOKING_ASSiSTANT_AUTOMATION.EMAIL_ROUTING_DATA.SET,
		(state, action) => ({
			...state,
			emailRoutingData: action.emailRoutingData,
		})
	),
	on(BOOKING_ASSiSTANT_AUTOMATION.DISPATCH_USER.SET, (state, action) => ({
		...state,
		dispatchUserData: {
			...state.dispatchUserData,
			current: action.dispatchUser,
		},
	})),
	on(BOOKING_ASSiSTANT_AUTOMATION.DISPATCH_USER.UPDATE, (state, action) => ({
		...state,
		dispatchUserData: {
			...state.dispatchUserData,
			updated: action.dispatchUser,
		},
	})),
	on(BOOKING_ASSiSTANT_AUTOMATION.ACTIVE_USERS_LIST.SET, (state, action) => ({
		...state,
		activeUsersList: action.activeUsersList,
	})),
	on(BOOKING_ASSiSTANT_AUTOMATION.BOOKING_ASSISTANT_PAGE_DATA.SUCCESS, (state, action) => ({
		...state,
		loading: false,
		bookingAssistantDataFields: {
			...action.data,
			// Preserve bookingAssistantEnabledValue from the action (if present) or from current state
			bookingAssistantEnabledValue:
				action.data?.bookingAssistantEnabledValue ??
				action.isBookingAssistantEnabledChecked ??
				state.bookingAssistantDataFields?.bookingAssistantEnabledValue,
		},
	})),
	on(SessionActions.logout.start, () => ({ ...initialState }))
);
